import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createWorkflow,
  deleteWorkflow,
  getWorkflow,
  getWorkflows,
  getWorkflowsMasterData,
  updateWorkflow
} from '../../../api/workflows';
import { WorkflowStep } from '../WorkflowStep/workflowStepSlice';

export const getWorkflowsAsync = createAsyncThunk(
  'workflows/getWorkflows',
  getWorkflows
);

export const getWorkflowsMasterDataAsync = createAsyncThunk(
  'workflows/getWorkflowsMasterData',
  getWorkflowsMasterData
);

export const getWorkflowAsync = createAsyncThunk(
  'workflows/getWorkflow',
  getWorkflow
);

export const createWorkflowAsync = createAsyncThunk(
  'workflows/createWorkflow',
  createWorkflow
);

export const updateWorkflowAsync = createAsyncThunk(
  'workflows/updateWorkflow',
  updateWorkflow
);

export const deleteWorkflowAsync = createAsyncThunk(
  'workflows/deleteWorkflow',
  deleteWorkflow
);

export interface Workflow {
  id: number;
  name: string;
  workflowSteps: WorkflowStep[];
}

interface WorkflowState {
  data: Workflow[];
  masterData: Workflow[];
  count: number;
  selectedWorkflow: Workflow | null;
}

const initialState: WorkflowState = {
  data: [],
  masterData: [],
  count: 0,
  selectedWorkflow: null
};

export default createSlice({
  name: 'workflows',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkflowsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(getWorkflowsMasterDataAsync.fulfilled, (state, action) => {
      state.masterData = action.payload.data;
      state.count = action.payload.count;
    });
    builder.addCase(getWorkflowAsync.fulfilled, (state, action) => {
      state.selectedWorkflow = action.payload;
    });
  }
});
